export const servicesPageData = {
  hero: {
    badge: "Professional Technology Services",
    headline: "Technology Services Built Around Your Business",
    subtext:
      "From Laravel applications and APIs to SaaS, mobile, cloud and AI solutions, we build technology designed for performance, scalability and long-term growth.",
    primaryCTA: "Start Your Project",
    secondaryCTA: "Talk to a Laravel Expert",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20software%20engineering%20team%20workspace%2C%20multiple%20floating%20screens%20showing%20code%2C%20dashboards%20and%20APIs%2C%20blue%20and%20purple%20gradient%20lighting%2C%20abstract%20technology%20visualization%2C%20premium%20SaaS%20aesthetic%2C%20dark%20background%2C%20no%20people%2C%20no%20text&width=1400&height=800&seq=services-hero-1&orientation=landscape",
  },
  categories: [
    {
      id: "laravel",
      title: "Laravel & Backend Development",
      desc: "Build secure, scalable and high-performance web applications with experienced Laravel developers.",
      icon: "ri-code-s-slash-line",
      featured: true,
      capabilities: [
        "Custom Laravel Applications",
        "Laravel API Development",
        "Laravel SaaS Development",
        "Laravel Enterprise Applications",
        "Laravel Migration",
        "Performance Optimization",
        "Laravel Maintenance",
        "Hire Laravel Developers",
      ],
      href: "/services/laravel-development",
      cta: "Explore Laravel Development",
    },
    {
      id: "web",
      title: "Web Application Development",
      desc: "Custom web applications designed around your business processes and user needs.",
      icon: "ri-window-line",
      capabilities: [
        "Custom Web Applications",
        "PHP Development",
        "Vue.js Development",
        "React Development",
        "Admin Panel Development",
        "CRM Development",
        "ERP Development",
        "Enterprise Applications",
      ],
      href: "/services/web-development",
      cta: "Explore Web Development",
    },
    {
      id: "mobile",
      title: "Mobile App Development",
      desc: "Cross-platform mobile applications powered by robust Laravel APIs and modern frameworks.",
      icon: "ri-smartphone-line",
      capabilities: [
        "Flutter Development",
        "Android Development",
        "iOS Development",
        "Cross-platform Applications",
        "Mobile APIs",
        "Push Notifications",
      ],
      href: "/services/mobile-app-development",
      cta: "Explore Mobile Development",
    },
    {
      id: "ai",
      title: "AI & AI Development",
      desc: "Integrate modern AI capabilities into your applications, SaaS platforms and business workflows.",
      icon: "ri-bard-line",
      capabilities: [
        "AI Integration",
        "AI-Powered Applications",
        "ChatGPT Integration",
        "Claude Integration",
        "AI Chatbots",
        "AI Assistants",
        "AI Workflow Automation",
        "AI API Integration",
        "AI-powered SaaS",
      ],
      href: "/services/ai-development",
      cta: "Explore AI Development",
    },
    {
      id: "api",
      title: "API Development",
      desc: "Secure and scalable REST APIs, third-party integrations and microservices.",
      icon: "ri-exchange-line",
      capabilities: [
        "REST API Development",
        "Laravel APIs",
        "Mobile APIs",
        "Third-party Integrations",
        "Payment APIs",
        "Authentication & Authorization",
        "API Security",
        "API Performance",
      ],
      href: "/services/api-development",
      cta: "Explore API Development",
    },
    {
      id: "saas",
      title: "SaaS Development",
      desc: "Multi-tenant SaaS platforms with subscriptions, analytics and scalable architecture.",
      icon: "ri-cloud-line",
      capabilities: [
        "SaaS Product Development",
        "Multi-tenancy Architecture",
        "Subscription Management",
        "Payment Integration",
        "User Management",
        "Roles & Permissions",
        "Admin Dashboards",
        "Analytics & Notifications",
      ],
      href: "/services/saas-development",
      cta: "Explore SaaS Development",
    },
    {
      id: "cloud",
      title: "Cloud & DevOps",
      desc: "AWS deployment, Docker, CI/CD, monitoring and scalable cloud infrastructure.",
      icon: "ri-server-line",
      capabilities: [
        "AWS",
        "Cloud Deployment",
        "Docker & Containerization",
        "CI/CD Pipelines",
        "Cloudflare & CDN",
        "Server Monitoring",
        "Automated Backups",
        "Security & Compliance",
        "Infrastructure Performance",
      ],
      href: "/services/cloud-devops",
      cta: "Explore Cloud & DevOps",
    },
    {
      id: "uiux",
      title: "UI/UX & Product Design",
      desc: "Modern interfaces and design systems focused on usability and conversion.",
      icon: "ri-palette-line",
      capabilities: [
        "UI/UX Design",
        "Web Design",
        "Mobile App UI/UX",
        "Dashboard Design",
        "SaaS Product Design",
        "Design Systems",
      ],
      href: "/services/ui-ux-design",
      cta: "Explore UI/UX Design",
    },
    {
      id: "maintenance",
      title: "Maintenance & Support",
      desc: "Long-term technical support, optimization and continuous improvements.",
      icon: "ri-tools-line",
      capabilities: [
        "Application Maintenance",
        "Bug Fixing & Hotfixes",
        "Performance Optimization",
        "Security Updates",
        "Server Maintenance",
        "Long-Term Technical Support",
      ],
      href: "/services/maintenance-support",
      cta: "Get Technical Support",
    },
  ],
  whyChooseUs: [
    { title: "Laravel Expertise", desc: "Deep experience building production-ready Laravel applications.", icon: "ri-code-box-line" },
    { title: "Scalable Architecture", desc: "Systems designed to grow with your business needs.", icon: "ri-arrow-right-up-line" },
    { title: "Clean Code", desc: "Structured code designed for long-term maintenance.", icon: "ri-file-code-line" },
    { title: "Performance Focus", desc: "Fast APIs, optimized databases and efficient infrastructure.", icon: "ri-speed-line" },
    { title: "Security First", desc: "Built with security best practices at every layer.", icon: "ri-shield-check-line" },
    { title: "Long-Term Support", desc: "Continuous technical support after launch.", icon: "ri-heart-3-line" },
  ],
  clientOutcomes: [
    { number: "01", title: "Scalable Products", desc: "Architecture that grows with your users and business.", icon: "ri-expand-diagonal-line", gradient: "from-[#2563EB] to-[#7C3AED]" },
    { number: "02", title: "Faster Performance", desc: "Optimized APIs, databases and infrastructure.", icon: "ri-flashlight-line", gradient: "from-[#7C3AED] to-[#F97316]" },
    { number: "03", title: "Reduced Technical Debt", desc: "Clean architecture from day one.", icon: "ri-git-pull-request-line", gradient: "from-[#F97316] to-[#F59E0B]" },
    { number: "04", title: "Reliable Infrastructure", desc: "Production-ready cloud and DevOps setup.", icon: "ri-server-line", gradient: "from-[#2563EB] to-[#F97316]" },
  ],
  faq: [
    { q: "How do you approach a new project?", a: "We start with a comprehensive discovery phase to understand your business requirements, followed by architecture planning, UI/UX design, development with agile sprints, testing and deployment." },
    { q: "What is your Laravel development expertise?", a: "Our team has 10+ years of combined Laravel experience building applications ranging from MVPs to enterprise systems. We specialize in API development, SaaS platforms, performance optimization and cloud deployment." },
    { q: "Can you build a SaaS platform using Laravel?", a: "Yes, we have extensive experience building multi-tenant SaaS platforms using Laravel with features like subscription billing, role-based access, API integrations and scalable cloud infrastructure." },
    { q: "Do you provide long-term maintenance?", a: "Absolutely. We offer flexible maintenance packages including security updates, bug fixes, performance monitoring, feature enhancements and 24/7 emergency support." },
    { q: "How do you handle project communication?", a: "We use modern tools like Slack, Jira and Trello for transparent communication. We provide weekly updates, bi-weekly demos and are always available for questions." },
  ],
  cta: {
    heading: "Have a project in mind?",
    text: "Let's build something that scales.",
    primaryCTA: "Start Your Project",
    secondaryCTA: "Talk to a Laravel Expert",
  },
};